import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export var res;
export const configurationListTodo = createAsyncThunk('configurationList', async (data) => {
    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'configuration',
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') },

        })
        return res

    } catch (error) {
        return error?.response
    }
});

const configurationListSlice = createSlice({
    name: 'configurationList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(configurationListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status == 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status == 401) {
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            }
            // else if (action?.payload?.status == 400 || action?.payload?.status == 404) {
            //     toast.error(action?.payload?.status == 400 ? res?.payload?.data?.message : 'Not Found', { position: "bottom-right" });
            // }
            else {
                state.data = []
                // toast.error('Something Went Wrong...!!', { position: "bottom-right" });
            }
        });
        builder.addCase(configurationListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default configurationListSlice.reducer; 